import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import SnackBar from './SnackBar';
import Banner from '../assets/images/banner.jpg';
import Indflag from '../assets/images/indian_flag.png';
import GBPflag from '../assets/images/britain_flag.png';
import USAflag from '../assets/images/USA_flag.png';
import CADflag from '../assets/images/Canada_flag.png';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
import Loader from './Loader';
import { MenuItem, TextField } from '@mui/material';


// okasboxes add new device

const customStyles = {
  content: {
    top: '40%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // border:'1px solid red',
    // minHeight: '10%',
    // maxHeight: '70%',
    height: '85%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const ObType = [
  { imageSrc: Indflag, label: ' INR' },
  { imageSrc: GBPflag, label: 'GBP' },
  { imageSrc: USAflag, label: 'USD' },
  { imageSrc: CADflag, label: 'CAD' },

];

// console.log('55',ObType)


export default class SubscriptionsAddPlans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //   modalIsOpen: this.props.activeModal,
      modalIsOpenAddSUBPlans: this.props.activeModal,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
      noOfParams: [],
      ObSerialNo: '',
      ObRegistrationId: '',
      ObLicenseId: '',
      SiEmail: '',
      ObLicenseId: '',
      SiMobile: '',
      SiArea: '',
      SiAddress: '',
      SiDescription: '',
      SiRating: '',
      ObType: '',
      errorMessage: [],
      modalIsOpenSuccess: false,
      modalIsOpenAddSUBPlansSuccess: false,

      showErrorMessage: false,
      OBAvailable: true,
      addAnotherSuccess: false,
      publicVersion: [],
      loader: false,
      snackbarActive: false,
      snackbarMessage: ''
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    // this.setState({ modalIsOpen: true });
    this.setState({ modalIsOpenAddSUBPlans: true });
  }
  // closeModalSuccess() {
  //   this.props.refreshDevices();
  //   this.setState({
  //     modalIsOpenSuccess: false
  //   });
  // }

  closeModalSuccess() {
    // this.props.refreshDevices()
    // const history = createHistory({ forceRefresh: true })
    // history.push('/okasboxes/dashboard')
    this.setState({
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          //   modalIsOpenSuccess: false,
          modalIsOpenAddSUBPlansSuccess: false
        }, () => this.props.refreshDevices())
      }, 500);

    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          //   modalIsOpen: false,
          modalIsOpenAddSUBPlans: false
        })
        this.props.refreshDevices()
      }, 500);

    })
  }

  onSelectChange = (operationMode, valueSelect) => {
    console.log(valueSelect)
    if (operationMode === 'obType') {
      this.setState({
        ObType: valueSelect.value,
        errorMessage: []
      })
    } else if (operationMode === 'obVersion') {
      this.setState({
        ObLicenseId: valueSelect.value,
        errorMessage: []
      })
    }
  }

  fetchDevices = (someCall) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasBoxApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        someCall(data)
        this.setState({
          boxesData: data,
        })
        return data
      })
  }



  componentDidMount() {
    this.fecthAllSI();
    this.fetchPublicVersion()
  }

  fecthAllSI = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/si_IntegratorApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          obData: data
        }, () => console.log(this.state))
      })
  }

  AddingOB = () => {
    let okasBox_type = this.state.ObType;
    let okasBox_serialNo = this.state.ObRegistrationId.trim();
    let okasBox_version = this.state.ObLicenseId.trim();

    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    this.fetchDevices((device, as) => {
      var deviceFound = false;
      device.forEach((e) => {
        if (e.okasBox_serialNo === okasBox_serialNo) {
          deviceFound = true
        }
      })
      if (deviceFound) {
        this.setState({
          loader: false,
          snackbarMessage: 'Serial No. already existing. Please enter a new Serial No.',
          snackbarActive: true
        })
      } else {
        fetch('/cloud/okasBoxApi/', {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            okasBox_type,
            okasBox_serialNo,
            okasBox_version,
          })
        })
          .then(response => {
            if (response.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('csrftoken');
              localStorage.removeItem('auth');
              // const history = createHistory({ forceRefresh: true })
              window.location.href = '/session-timeout'
            } else {
              return response.json()
            }
          })
          .then(data => {
            if (data.message !== "failure") {
              this.setState({
                // modalIsOpen: false,
                modalIsOpenAddSUBPlans: false,
                modalIsOpenSuccess: true,
                modalIsOpenAddSUBPlansSuccess: true,
                obData: data,
                loader: false
              })
            }
          });
      }
    });

  }

  AddingAnotherOB = () => {
    let okasBox_type = this.state.ObType;
    let okasBox_serialNo = this.state.ObRegistrationId.trim();
    let okasBox_version = this.state.ObLicenseId.trim();

    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    this.fetchDevices((device, as) => {
      var deviceFound = false;
      device.forEach((e) => {
        if (e.okasBox_serialNo === okasBox_serialNo) {
          deviceFound = true
        }
      })
      if (deviceFound) {
        this.setState({
          loader: false,
          snackbarMessage: 'Serial No. already existing. Please enter a new Serial No.',
          snackbarActive: true
        })
      } else {
        fetch('/cloud/okasBoxApi/', {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            okasBox_type,
            okasBox_serialNo,
            okasBox_version,
          })
        })
          .then(response => {
            if (response.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('csrftoken');
              localStorage.removeItem('auth');
              // const history = createHistory({ forceRefresh: true })
              window.location.href = '/session-timeout'
            } else {
              return response.json()
            }
          })
          .then(data => {
            if (data.message !== "failure") {
              this.setState({
                // modalIsOpen: false,
                modalIsOpenAddSUBPlans: false,
                addAnotherSuccess: true,
                obData: data,
                loader: false
              }, () => {
                setTimeout(() => {
                  this.setState({
                    addAnotherSuccess: false
                  })
                }, 3000)
                this.setState({
                  //   modalIsOpen: true,
                  modalIsOpenAddSUBPlans: true,
                  ObType: '',
                  ObSerialNo: '',
                  ObRegistrationId: '',
                  ObLicenseId: '',
                  showErrorMessage: false
                }, () => this.fetch)
              })
            } else {
              this.setState({
                loader: false
              }, () => {
                alert('Serial No. already existing. Please enter a new Serial No.');
                // const history = createHistory({ forceRefresh: true })
                window.location.href = '/okasboxes/dashboard'
              })
            }
          })
          .catch((err) => {
            console.log(err)

          })
      }
    });
  }


  AddOB = () => {
    this.setState({
      showErrorMessage: true
    }, () => {
      this.fetchError((e) => {
        if (e === 'NoError') {
          this.setState({
            loader: true
          }, () => {
            this.AddingOB();
          })
        }
      })
    })
  }

  AddAnotherOB = () => {
    this.setState({
      showErrorMessage: true
    }, () => {
      this.fetchError((e) => {
        if (e === 'NoError') {
          this.setState({
            loader: true
          }, () => {
            this.AddingAnotherOB();
          })
        }
      })
    })
  }



  fetchError = (noError) => {
    var totalError = 3;
    if (ErrorText('notEmpty', this.state.ObType) === 'No Error') {
      totalError = totalError - 1;
    }

    if (ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) === 'No Error') {
      totalError = totalError - 1;
    }

    if (ErrorText('notEmpty', this.state.ObLicenseId.trim()) === 'No Error') {
      totalError = totalError - 1;
    }

    if (totalError === 0) {
      noError('NoError');
    }
  }

  handleChangeInputBox = (name, event) => {
    this.setState({
      [name]: event
    })
  };

  fetchPublicVersion = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasVersionApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        if (data.detail === 'Invalid token.') {
          localStorage.clear();
        } else {
          console.log(data)
          let publicVersion = [];
          data.forEach((sumValue) => {
            publicVersion.push({ label: sumValue.major.okas_product_version })
          })
          this.setState({ publicVersion })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
          this.setState({
            snackbarActive: false
          })
        }} message={this.state.snackbarMessage} />
        <Modal
          isOpen={this.state.modalIsOpenAddSUBPlans}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase" style={{ color: '#888888', fontSize: '30px', marginBottom: '30px' }}>ADD PLAN</h3>
          <div className="row">
            {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
              Successfully registered the OKAS Box.
            </div> : null}
          </div>
          <div className="row" style={{ margin: '0px', padding: '0px' }}>
            <div className="col-12 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
              <InputBox
                inputText={this.state.ObRegistrationId}
                error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Serial No. of 6-16 alphanumeric characters' : ''}
                placeholder="Plan Name"
                inputBoxName="ObRegistrationId"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={16}
                validate={true}
              />
            </div>
            <div className="col-12 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
              <InputBox
                inputText={this.state.ObRegistrationId}
                error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Serial No. of 6-16 alphanumeric characters' : ''}
                placeholder="Fees"
                inputBoxName="ObRegistrationId"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={16}
                validate={true}
              />
            </div>
            <div className="col-12 text-field-modal pl-0 " style={{ padding: '0px 15px 0px 0px', marginTop: '12px' }} >
              {/* <IntegrationReactSelectNew
                placeholder=""
                multipleSelect={false}
                content={ObType}
                onSelect={this.onSelectChange.bind(this, 'obType')}
                IntegrationReactSelectNewLabel="Currency"
                errorText={this.state.ObType === '' && this.state.showErrorMessage ? 'Please select the Currency Type' : ''}
              /> */}
              <TextField
                select
                variant="standard"
                fullWidth
                label="Currency"
                value={this.state.ObType || ''}
                onChange={(e) => this.onSelectChange('obType', e.target.value)}
                error={this.state.ObType === '' && this.state.showErrorMessage}
                helperText={
                  this.state.ObType === '' && this.state.showErrorMessage
                    ? 'Please select the Currency Type'
                    : ''
                }
              >
                <MenuItem value="" disabled>
                  Select Currency Type
                </MenuItem>
                {ObType.map((option, index) => (
                  <MenuItem key={index} value={option.label}>
                    {option.imageSrc && (
                      <img
                        src={option.imageSrc}
                        alt={option.label}
                        style={{
                          width: '20px',
                          height: '15px',
                          marginRight: '8px',
                          objectFit: 'cover',
                          verticalAlign: 'middle'
                        }}
                      />
                    )}
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

            </div>

            <div className="col-12 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
              <InputBox
                inputText={this.state.ObRegistrationId}
                error={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? true : false}
                errorText={ErrorText('isOkasBoxSerialNumber', this.state.ObRegistrationId.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid Serial No. of 6-16 alphanumeric characters' : ''}
                placeholder="Feature (Upto 10 features can be added)"
                inputBoxName="ObRegistrationId"
                multipleSelect={true}
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={16}
                validate={true}
              />
            </div>

          </div>
          <div className="float-right" style={{ marginTop: '70px', marginBottom: '70px' }}>
            <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Close</div>
            <div className="btn btn-new-orange" style={{ marginRight: '15px' }} onClick={this.AddAnotherOB.bind(this)}>Add Another</div>
            <div className="btn btn-new-green"
              onClick={() => {
                this.setState({
                  loader: true
                }, () => {
                  this.AddOB()
                })
              }}
              onClick={this.AddOB.bind(this)}
            >Save</div>
          </div>
        </Modal>




        <Modal
          isOpen={this.state.modalIsOpenAddSUBPlansSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalSuccess}>
              <i className="fas   fa-2x mr-2" onClick={this.closeModalSuccess}></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">OKAS Box added successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5"
              // onClick={(e) => {
              //   const history = createHistory({ forceRefresh: true })
              //   history.push('/okasboxes/dashboard')
              // }}
              onClick={this.closeModalSuccess}
            >
              Close
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
